import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconHome';
/** Renders an SVG icon. */
const SvgHome = ({ size, 'aria-hidden': ariaHidden, tone, UNSAFE_className, UNSAFE_style, ...rest }: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M14.78 3.676a2 2 0 0 1 2.44 0l12.39 9.531a1 1 0 0 1-1.22 1.586l-.39-.3V26a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V14.492l-.39.3a1 1 0 1 1-1.22-1.585l12.39-9.53ZM6 12.955V26h6v-7.5a1.5 1.5 0 0 1 1.5-1.5h5a1.5 1.5 0 0 1 1.5 1.5V26h6V13l.001-.045L16 5.262 5.999 12.955ZM18 26v-7h-4v7z"
      />
    </svg>
  );
};
SvgHome.displayName = displayName;
export default SvgHome;
